export default __webpack_public_path__ + "static/media/arrow.de4b5b5e.svg";